export const environment = {
  production: true, webapiendpoint: "prod", SSOEnabled: false,
  DEVEXTREME_KEY: window["env"]["DEVEXTREME_KEY"] || false,
  ISDOCKER: window["env"]["ISDOCKER"] || false,
  RISKCUBEDAUTHSERVERURL: window["env"]["RISKCUBEDAUTHSERVERURL"] || "default",
  RISKCUBEDAPI: window["env"]["RISKCUBEDAPI"] || "default",
  PLAPIURL: window["env"]["PLAPIURL"] || "default"
};
